function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "m19.1427 7.63953h-10.4762v14.05107c0 1.4722 1.19165 2.6658 2.6638 2.6667 2.4363.0013 5.803.0031 6.7648.0031v-3.3958h2.0952v3.3958l.4802-.0007c1.4712-.0022 2.6627-1.1955 2.6627-2.6667v-1.4423-4.0451h-8.381v8.1501h-1.0617v-9.1019h5.2522z",
  fill: "#303030"
});

function SvgEnterprise(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 32,
    viewBox: "0 0 32 32",
    width: 32
  }, props), _ref);
}

export default "data:image/svg+xml;base64,";
export { SvgEnterprise as ReactComponent };